import * as React from 'react';

export const ArrowUpRight = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M10.8877 10.0875L10.9124 3.08747M10.9124 3.08747L3.91237 3.11217M10.9124 3.08747L3.08738 10.9125"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
);

export const ChevronLeft = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M9 11L5 7L9 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M5 3L9 7L5 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Chevron = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    className={className}
    color="currentColor"
  >
    <path
      d="M19.8799 8.06055L11.9996 15.9407L4.11951 8.06055"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </svg>
);

export const Check = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M10 3 4.75 8.25 2 5.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DropdownArrow = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M15.2148 9.75015L4.87891 9.74985V4.42969M15.2148 9.75015L11.6674 6.20287M15.2148 9.75015L11.6674 13.2971"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </svg>
);

export const XLogo = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M11.861 8.469 19.152 0h-1.728l-6.33 7.353L6.038 0H.207l7.646 11.119L.207 20h1.728l6.685-7.765L13.962 20h5.831l-7.932-11.531Zm-2.367 2.75-.775-1.108L2.557 1.3h2.653l4.974 7.113.775 1.108 6.466 9.247h-2.653l-5.278-7.549Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkedinLogo = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M4.477 20H.33V6.64h4.147V20ZM2.401 4.817a2.409 2.409 0 1 1 0-4.817 2.409 2.409 0 0 1 0 4.817ZM19.995 20h-4.138v-6.5c0-1.55-.031-3.543-2.16-3.543-2.16 0-2.49 1.688-2.49 3.431V20H7.064V6.64h3.978v1.823h.058c.553-1.049 1.906-2.158 3.922-2.158 4.195 0 4.973 2.762 4.973 6.348V20Z"
      fill="currentColor"
    />
  </svg>
);
